export const TextAreaField: React.FC<{
  parentClassName?: string;
  label: string;
  labelClassName?: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  value: string;
  characterLimit?: number;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
}> = ({
  parentClassName = "",
  label,
  labelClassName,
  placeholder,
  value,
  required = false,
  onChange,
  disabled,
  characterLimit = 100,
}) => {
  return (
    <div>
      <h2 className={`mb-5 ${labelClassName || "label-light-blue-xl"}`}>
        {label}
        {required && <span className="text-red-500"> *</span>}
      </h2>
      <textarea
        placeholder={placeholder}
        className={
          parentClassName
            ? parentClassName
            : disabled
            ? "form-text-field-border-gray min-h-100"
            : "form-text-field-border min-h-50"
        }
        value={value || ""}
        required={required}
        disabled={disabled}
        maxLength={characterLimit}
        onChange={(e) => onChange(e)}
      />
    </div>
  );
};
